<template>
    <header class="site-header" :class="bottomOuterDivider && 'has-bottom-divider'">
        <div class="container">
            <div class="site-header-inner" :class="bottomDivider && 'has-bottom-divider'">
                <c-logo />
                <button
                    v-if="!hideNav"
                    ref="hamburger"
                    class="header-nav-toggle"
                    aria-controls="primary-menu"
                    :aria-expanded="isActive ? 'true' : 'false'"
                    @click="isActive ? closeMenu() : openMenu()">
                    <span class="screen-reader">Menu</span>
                    <span class="hamburger">
                        <span class="hamburger-inner"></span>
                    </span>
                </button>
                <nav
                    v-if="!hideNav"
                    ref="nav"
                    class="header-nav"
                    :class="{ 'is-active': isActive }">
                    <div class="header-nav-inner">
                        <ul
                            class="list-reset text-xxs"
                            :class="navPosition && `header-nav-${navPosition}`">
                            <li>
                                <router-link to="/">HOME</router-link>
                            </li>|
                            <li>
                                <router-link to="/tracking">物流跟踪</router-link>
                            </li>|
                            <li>
                                <router-link to="/document/?N">最新动态</router-link>
                            </li>|
                            <li>
                                <router-link to="/document/?H">常用文档</router-link>
                            </li>|
                            <li>
                                <router-link to="/contact/">联系我们</router-link>
                            </li>|
                            <li>
                                <div  @mouseenter="setTip($event)" @mouseleave="hiddenTip">&nbsp;&nbsp;&nbsp;&nbsp;一号线手机端</div>
                            </li>
                        </ul>
                        <ul v-if="!hideSignin" class="list-reset header-nav-right">
                            <li>
                                <a href="https://system.line-1.com" target="_blank" class="button button-primary button-wide-mobile button-sm">会员中心</a>
                            </li>
                        </ul>
                    </div>
                </nav>
            </div>
        </div>
    </header>
</template>

<script>
import CLogo from '@/components/layout/partials/Logo.vue'
import Vue from 'vue';
import Vtip from 'vtip'
import 'vtip/lib/index.min.css'
// 注册指令使用
Vue.use(Vtip.directive)
// 工具函数调用
Vue.prototype.$tip = Vtip.tip

var tipContent = {
  template: `
  <div :style="{ width: '170px', height: '200px'}">
    <div style="margin-left: 10px;"><img width="150" height="150" :src="link"/></div>
    <h6 style="margin-left:10px;">扫一扫 关注公众号</h6>
  </div>`,
  computed: {
    link () {
      return require('@/assets/images/lineone.jpg')
    }
  }
}

export default {
  name: 'CHeader',
  components: {
    CLogo
  },
  props: {
    active: Boolean,
    navPosition: {
      type: String,
      default: ''
    },
    hideNav: {
      type: Boolean,
      default: false
    },
    hideSignin: {
      type: Boolean,
      default: false
    },
    bottomOuterDivider: {
      type: Boolean,
      default: false
    },    
    bottomDivider: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isActive: this.active || false,
    }
  },
  watch: {
    active(value) {
      this.isActive = value
    }
  },
  methods: {
    // 工具函数使用
    setTip ({ target }) {
      this.tipInstance = this.$tip({
        target,
        width: 'auto',
        transition: true,
        customComponent: tipContent
      })
    },
    
    hiddenTip ({ target }) {
      const { tipInstance } = this
      if (tipInstance && tipInstance.target === target) {
        tipInstance.hiddenTip()
      }
    },
    openMenu() {
      document.body.classList.add('off-nav-is-active')
      if (this.$refs.nav)
        this.$refs.nav.style.maxHeight = this.$refs.nav.scrollHeight + 'px'
      this.$emit('update:active', true)
      this.isActive = true
    },
    closeMenu() {
      document.body.classList.remove('off-nav-is-active')
      if (this.$refs.nav) this.$refs.nav.style.maxHeight = null
      this.$emit('close')
      this.$emit('update:active', false)
      this.isActive = false
    },
    keyPress() {
      this.isActive && event.keyCode === 27 && this.closeMenu()
    },
    clickOutside(e) {
      if (!this.$refs.nav) return
      if (
        !this.isActive ||
        this.$refs.nav.contains(e.target) ||
        e.target === this.$refs.hamburger
      )
        return
      this.closeMenu()
    }
  },
  mounted() {
    this.active && this.openMenu()
    document.addEventListener('keydown', this.keyPress)
    document.addEventListener('click', this.clickOutside)
  },
  beforeDestroy() {
    document.addEventListener('keydown', this.keyPress)
    document.removeEventListener('click', this.clickOutside)
    this.closeMenu()
  }
}
</script>